import * as React from 'react';
import styled from 'styled-components';

import { FormContext } from '../context/FormContextProvider';
import { Checkbox } from './Checkbox';
import { useCheckActiveOffice } from '../../../../utils/hooks/useCheckActiveOffice';

import { GetPropertyVisningspaamelding } from '../../../../../__types__/generated/GetPropertyVisningspaamelding';
import { InputError } from './InputError';
import { useQuery } from '@apollo/client';
import { GET_SAMTYKKER } from '../graphql/queries';
import { client } from '../../../../../../client/__graphql__/client';

interface IConsents {
  showValuation?: boolean;
  showPrinted?: boolean;
  printedConsentError?: string;
  data: GetPropertyVisningspaamelding;
  marketing?: boolean;
}

export const Consents: React.FC<IConsents> = React.memo(
  ({ showValuation, showPrinted, printedConsentError, data, marketing }) => {
    const {
      valuation,
      setValuation,
      printed,
      setPrinted,
      setSamtykkeIds,
      samtykkeIds,
    } = React.useContext(FormContext);
    const { active } = useCheckActiveOffice();
    const {
      data: samtykker,
      loading,
      error,
    } = useQuery(GET_SAMTYKKER, {
      client: client,
      variables: { ids: [5] },
      fetchPolicy: 'cache-first',
    });
    console.log('samtykker', samtykker);
    return (
      <>
        {active &&
        showPrinted &&
        data?.getProperty?.assignmentType !== 'NYBYGG' &&
        !data?.getProperty?.type?.match(/tomt/g) &&
        data?.getProperty?.hovedoppdrag !== -1 ? (
          <>
            {printedConsentError ? (
              <InputError style={{ marginTop: '30px', marginBottom: 0 }}>
                {printedConsentError}
              </InputError>
            ) : null}
            <StyledConsents
              style={{ marginTop: printedConsentError ? '10px' : '30px' }}
            >
              <h3>
                Bestill trykket boligpresentasjon til visning. (Kostnadsfritt)
              </h3>
              <Checkbox
                labelPos="right"
                label="Ja takk."
                checked={printed}
                onClick={() => setPrinted(!printed)}
              />
            </StyledConsents>
          </>
        ) : null}

        {showValuation ? (
          <StyledConsents>
            <h1>Verdivurdering av din bolig?</h1>
            <Checkbox
              labelPos="right"
              label="Jeg ønsker å bli kontaktet for verdivurdering av egen bolig."
              checked={valuation}
              onClick={() => setValuation(!valuation)}
            />
          </StyledConsents>
        ) : null}

        {marketing ? (
          <StyledConsents className="marketing">
            <Checkbox
              labelPos="right"
              label={samtykker?.getAvailableSamtykkerByIds[0]?.samtykketekst}
              checked={samtykkeIds.includes(
                samtykker?.getAvailableSamtykkerByIds[0]?.id
              )}
              onClick={() =>
                setSamtykkeIds(samtykker?.getAvailableSamtykkerByIds[0]?.id)
              }
            />
          </StyledConsents>
        ) : null}
      </>
    );
  }
);

const StyledConsents = styled.div`
  width: 100%;
  padding: 20px;
  margin-bottom: 20px;
  background: rgb(40, 40, 40);

  h1 {
    margin-top: 0;
    font-size: 28px;
    text-align: left !important;
  }

  h3 {
    font-size: 1.3em;
    margin-top: 0;
    text-align: left !important;
  }

  p {
    margin-top: 0;
    margin-bottom: 20px;
    text-align: left !important;
  }
  &.marketing {
    padding: 20px 0;
    background: none;
  }
`;
